<template lang="pug">
form.BaseForm(
  :id="id || formId",
  novalidate="novalidate",
  ref="form",
)
  slot
  input.d-none(
    v-if="honeypot"
    type="text"
    :id="honeypotFieldName"
    :name="honeypotFieldName"
    autocomplete="off"
  )
</template>

<script>
import BaseFormModel from 'Models/BaseFormModel';
import CONFIG from 'Config';

export default {
  name: 'BaseForm',
  provide() {
    return {
      formLoading: this.loadingWrapper,
      componentLoadingContainer: this.componentLoadingContainer,
      formId: this.formId || this.id,
    };
  },
  props: {
    id: [String, Number],
    formId: [String, Number],
    model: {
      type: BaseFormModel,
      default: () => new BaseFormModel(),
    },
    loadingSend: Boolean,
    loadingPre: Boolean,
    keepLoadingSendOnSuccess: Boolean,
    honeypot: Boolean,
  },
  data() {
    return {
      loadingWrapper: {
        all: false,
        send: false,
        pre: false,
      },
      componentLoadingContainer: {},
    };
  },
  computed: {
    isLoadingAll() {
      return this.model.$loading || this.isLoadingPre;
    },
    isLoadingSend() {
      return this.model.$loadingSend
        || this.loadingSend
        || (this.keepLoadingSendOnSuccess && this.model.$sendSuccess);
    },
    isLoadingPre() {
      return this.model.$loadingPre
        || this.loadingPre
        || this.isInputComponentLoading;
    },
    isInputComponentLoading() {
      return Object.values(this.componentLoadingContainer).some(val => val);
    },
  },
  watch: {
    isLoadingAll: {
      handler(val) {
        this.loadingWrapper.all = val;
      },
      immediate: true,
    },
    isLoadingSend: {
      handler(val) {
        this.loadingWrapper.send = val;
      },
      immediate: true,
    },
    isLoadingPre: {
      handler(val) {
        this.loadingWrapper.pre = val;
      },
      immediate: true,
    },
  },
  mounted() {
    this.$parent.$formEl = this.$refs.form;
  },
  staticData: {
    honeypotFieldName: CONFIG.honeypotFieldName,
  },
};
</script>
